import { CatalystInsightType } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { TooltipContainer } from '~/components/tooltip-container/TooltipContainer';

import { CatalystInsightIcon } from '../catalyst-insight-icon/CatalystInsightIcon';
import { getCatalystInsightIconProps } from '../catalyst-insight-icon/utils';
import { CatalystInsightTooltip } from '../catalyst-insight-tooltip/CatalystInsightTooltip';
import { useCatalystDrawer } from '../useCatalystDrawer';
import * as S from './CatalystInsightPill.styles';

export interface CatalystInsightPillProps {
  insightId: string;
  entityTag?: string;
  themeId?: string;
  category: CatalystInsightType;
  isClickable?: boolean;
}

export const CatalystInsightPill = ({
  insightId,
  entityTag,
  themeId,
  category,
  isClickable = false,
}: CatalystInsightPillProps) => {
  const { t } = useTranslation(['insights']);
  const { openDrawer } = useCatalystDrawer();

  const handleClick = () => {
    if (isClickable) {
      if (entityTag) {
        openDrawer({ type: 'company', entityTag, insightId });
      } else if (themeId) {
        openDrawer({ type: 'theme', themeId, insightId });
      }
    }
  };

  const isCompanyCatalyst = category === 'company';

  return (
    <TooltipContainer
      label={
        <CatalystInsightTooltip
          insightId={insightId}
          category={category}
          iconProps={getCatalystInsightIconProps({ isBordered: false })}
        />
      }
      placement="top-start"
      offsetY={-5}
      offsetX={8}
      hasMaxWidth={false}
      disabled={!isClickable}
      inPortal
      withSafePolygon
    >
      <S.CatalystInsightWrapper
        data-testid="catalyst-insight-pill"
        $isClickable={isClickable}
        onClick={handleClick}
      >
        <CatalystInsightIcon
          size={12}
          enableHover={false}
          isBordered={false}
          catalystInsightId={insightId}
          type={category}
        />
        <S.CatalystInsightLabel>
          {isCompanyCatalyst
            ? t('insights:catalyst.titleCompanyCatalyst')
            : t('insights:catalyst.titleMarketCatalyst')}
        </S.CatalystInsightLabel>
      </S.CatalystInsightWrapper>
    </TooltipContainer>
  );
};
